export { BaseContentBox, BaseContentBoxProps } from './base-content-box';